import React from "react";
import { Route, Routes } from "react-router-dom";
import Page404 from "../pages/404";
import Home from "../pages/home";
import ProductUSDCards from "../pages/products/p-usd-cards";
import ProductInvoicing from "../pages/products/p-invoicing";
import ProductAccounts from "../pages/products/p-accounts";
import ProductAccounts360 from "../pages/products/p-accounts-360";
import ProductBusinessPayments from "../pages/products/p-b-payments";
import ProductGlobalPayments from "../pages/products/p-g-payments";
import ProductVendorPortal from "../pages/products/p-vendor";
import ProductApprovalPolicies from "../pages/products/p-approval";



const BusinessRoutes = () => {
  return (
    <Routes>
        <Route path="*" element={<Page404 />} />
        <Route index element={<Home />} />
        <Route path="/business" element={<Home />} />
        <Route path="/business/products/usd-cards" element={<ProductUSDCards />} />
        <Route path="/business/products/invoicing" element={<ProductInvoicing />} />
        <Route path="/business/products/accounts" element={<ProductAccounts />} />
        <Route path="/business/products/accounts-360" element={<ProductAccounts360 />} />
        <Route path="/business/products/business-payments" element={<ProductBusinessPayments />} />
        <Route path="/business/products/global-payments" element={<ProductGlobalPayments />} />
        <Route path="/business/products/vendor-management" element={<ProductVendorPortal />} />
        <Route path="/business/products/approval-policies" element={<ProductApprovalPolicies />} />
    </Routes>
  );
};

export default BusinessRoutes;
